import { render } from "./KeyboardF1.vue?vue&type=template&id=147c724e"
import script from "./KeyboardF1.vue?vue&type=script&lang=js"
export * from "./KeyboardF1.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/KeyboardF1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "147c724e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('147c724e', __exports__)) {
    api.reload('147c724e', __exports__)
  }
  
  module.hot.accept("./KeyboardF1.vue?vue&type=template&id=147c724e", () => {
    api.rerender('147c724e', render)
  })

}


export default __exports__